import { initializeApp } from "firebase/app";
import { getMessaging,getToken } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);


export const getFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log('permission',permission)
    if (permission !== 'granted') {
      console.warn('Notification permission not granted');
      return null;
    }
    
   const token =  await getToken(messaging,{
      vapidKey:process.env.REACT_APP_FIREBASE_VAPID_KEY
    })
    // console.log('token',token)

    // // Register service worker explicitly
    // let registration;
    // try {
    //   registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
    //     scope: '/'
    //   });
    //   console.log('ServiceWorker registration successful:', registration);
    // } catch (swError) {
    //   console.error('ServiceWorker registration failed:', swError);
    //   return null;
    // }

    // // Get FCM token
    // const token = await getToken(messaging, {
    //   vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    //   serviceWorkerRegistration: registration
    // });

    return token || null;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};


if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration);

      // Use the registered service worker with messaging
      getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration,
      }).then((currentToken) => {
        if (currentToken) {
          console.log('FCM Token:', currentToken);
        } else {
          console.warn('No registration token available.');
        }
      });
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
}